import React from "react";
import { Link } from "react-router-dom";
import footerbg from "../../../assets/images/all-img/v4/footer-bg.png";
import starblack from "../../../assets/images/all-img/v4/star-black.png";
import logoblack from "../../../assets/images/logo/logo-black.svg";
import facebook from "../../../assets/images/social2/facebook.svg";
import github from "../../../assets/images/social2/github.svg";
import twitter from "../../../assets/images/social2/twitter.svg";

export default function FooterHomeFour() {
	return (
		<footer className="fugu--foote2-section" style={{ backgroundImage: `url(${footerbg})` }}>
			<div className="container">
				<div className="fugu--footer-top">
					<div className="fugu--default-content content-black">
						<h2 className="wow fadeInUpX" data-wow-delay="0s">
							Join our NFTs community
						</h2>
						<p className="wow fadeInUpX" data-wow-delay="0.15s">
							Meet artists & collectors for platform updates and get dozens of our extraordinary art
							collections in the world’s largest NFT marketplace.
						</p>
						<div className="fugu--btn-wrap wow fadeInUpX" data-wow-delay="0.25s">
							<Link to={"#"}  >
								<a className="fugu--btn bg-orange">Join Our Discord</a>
							</Link>
						</div>
						<div className="fugu--star">
							<img src={starblack} alt="" />
						</div>
					</div>
				</div>
				<div className="fugu--footer-middle">
					<div className="row">
						<div className="col-xl-3 col-lg-2">
							<div className="fugu--footer-logo">
								<img src={logoblack} alt="" />
							</div>
						</div>
						<div className="col-xl-6 col-lg-8">
							<div className="fugu--footer-menu2">
								<ul>
									<li>
										<Link to={"#"}> Demos </Link>
									</li>
									<li>
										<Link to={"about-us"}> About Us </Link>
									</li>
									<li>
										<Link to={"#"}> Collections </Link>
									</li>
									<li>
										<Link to={"#"}> Pages </Link>
									</li>
									<li>
										<Link to={"contact"}> Contact </Link>
									</li>
								</ul>
							</div>
						</div>
						<div className="col-xl-3 col-lg-2">
							<div className="fugu--social-icon fugu--social-icon2">
								<ul>
									<li>
										<Link to={"#"}>
											<img src={twitter} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={facebook} alt="" />
										</Link>
									</li>
									<li>
										<Link to={"#"}>
											<img src={github} alt="" />
										</Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="fugu--footer-bottom fugu--footer-bottom2">
					<div className="row">
						<div className="col-lg-6">
							<p>&copy; Copyright 2022, All Rights Reserved by Mthemeus</p>
						</div>
						<div className="col-lg-6">
							<div className="fugu--footer-menu">
								<ul>
									<li>
										<Link to={"#"}> Terms </Link>
									</li>
									<li>
										<Link to={"#"}> Privacy Policy </Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
}
